// @ts-strict-ignore
import { FC, useState } from 'react'

import { AccessoriesOfferModal } from '@/features/cart/accessories-offer'

import { TAccessoryGroup } from '@/shared/types/product-types'

import { AccessoriesList } from './accessories-list/accessories-list'
import { formatData } from './format-data'

import cl from './accessories-section.module.scss'

export interface AccessoriesListProps {
	title: string
	items: TAccessoryGroup[]
	relId: number
}

export const AccessoriesSection: FC<AccessoriesListProps> = ({ title, items, relId }) => {
	const [isOpen, setIsOpen] = useState(false)
	return (
		<section className={cl.section}>
			<div className={cl.wrapper}>
				<h2 className={cl.title}>{title}</h2>
				<AccessoriesList items={formatData(items)} relId={relId} />
			</div>
			<button className={cl.btnClear} onClick={() => setIsOpen(true)}>
				Смотреть все аксессуары
			</button>
			<AccessoriesOfferModal
				items={items}
				mainProductId={relId}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				title={'Добавить аксессуары'}
				onInCartClick={() => setIsOpen(false)}
				inCartLabel={'Вернуться в корзину'}
			/>
		</section>
	)
}
